import { render, staticRenderFns } from "./create_account.vue?vue&type=template&id=4ac36e46"
import script from "./create_account.vue?vue&type=script&lang=js"
export * from "./create_account.vue?vue&type=script&lang=js"
import style0 from "./create_account.vue?vue&type=style&index=0&id=4ac36e46&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports